import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Fog } from "@/components/Fog";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import { AuthCallback } from "@/components/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import VideoIdeaGenerator from "@/pages/VideoIdeaGenerator";
import ChallengeGenerator from "@/pages/ChallengeGenerator";
import BuildGenerator from "@/pages/BuildGenerator";
import Community from "@/pages/Community";
import Leaderboard from "@/pages/Leaderboard";
import Dashboard from "@/pages/Dashboard";
import PublicProfile from "@/pages/PublicProfile";
import SharedItem from "@/pages/SharedItem";
import SurvivorMaker from "@/pages/SurvivorMaker";
import EntityChat from "@/pages/EntityChat";
import Pricing from "@/pages/Pricing";
import UpgradeSuccess from "@/pages/UpgradeSuccess";
import Analytics from "@/pages/Analytics";

function Shell() {
  return (
    <>
      <Navbar />
      <main className="min-h-[70vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/video-ideas" element={<VideoIdeaGenerator />} />
          <Route path="/challenges" element={<ChallengeGenerator />} />
          <Route path="/builds" element={<BuildGenerator />} />
          <Route path="/survivor-maker" element={<SurvivorMaker />} />
          <Route path="/entity" element={<ProtectedRoute><EntityChat /></ProtectedRoute>} />
          <Route path="/community" element={<Community />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/upgrade/success" element={<UpgradeSuccess />} />
          <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/u/:username" element={<PublicProfile />} />
          <Route path="/share/:id" element={<SharedItem />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback BEFORE normal routing to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return <Shell />;
}

export default function App() {
  return (
    <div className="App relative">
      <Fog />
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}
